<div (click)="openAIAgent()">
    <img src="../../../../../assets/Icon-AI-Agent.svg" class="ai-agent-icon" />
</div>

<app-chat-flyout [(isOpen)]="showAIAgent" [headerText]="'Ecolab Virtual Assistant'"
    (isOpenChange)="closeAgentFlyout($event)" (onRightPanelToggle)="onToggleRightPanel($event)">
    <div panelHeader>
        <div class="new-chat-container" (click)="startNewChat()">
            <img src="../../../../assets/edit_square.svg" alt="New Chat" />
            <span class="new-chat-label">{{ 'AI_AGENT.NEW_CHAT' | translate }}</span>
        </div>

    </div>
    <div leftPanel class="col-12 chat-bot-container"> <!--*ngIf="contextPointId"-->
        <div class="chat-messages" #chatContainer>
            <div *ngIf="contextPointId && !isLoadingChat" class="messages-list">
                <div *ngFor="let message of messages; trackBy: trackByMessageId" class="message-wrapper"
                    [class.user-message]="isUserMessage(message)" [class.bot-message]="isBotMessage(message)">
                    <div *ngIf="isUserMessage(message)" class="message-bubble user-message-bubble">
                        <div class="message-content">{{ message.content.data }}</div>
                    </div>

                    <!-- Bot message rendered via eva-chat-content component -->
                    <nalco-eva-chat-content
                        *ngIf="isBotMessage(message)"
                        [message]="message"
                        [suggestions]="getEvaSuggestions(message)"
                        (suggestionSelected)="onChipSelection({ name: $event, value: $event, iconUrl: '' })"
                        (likeClicked)="sendFeedback($event.id, true)"
                        (dislikeClicked)="sendFeedback($event.id, false)">
                    </nalco-eva-chat-content>


                </div>

                <!-- Loading indicator -->
                <div *ngIf="isLoading" class="message-wrapper bot-message">
                    <div class="layered-icon" style="width: 50px;">
                        <img class="icon-background"
                            src="../../../../assets/Ecolab-Virtual-Agent-Chat-Logo.svg"
                            placement="left">
                    </div>
                    <div class="message-bubble loading">
                        <div class="message-header">
                        </div>

                        <div class="message-content">
                            <div class="typing-indicator">
                                <span class="typing-dot"></span>
                                <span class="typing-dot"></span>
                                <span class="typing-dot"></span>
                            </div>
                            <span class="typing-text">{{agentProcessingMessage}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
    <div rightPanel>
        <app-chat-history-list #chatHistoryList [showAIAgent]="showAIAgent"
            (chatHistorySelected)="onChatHistorySelected($event)"></app-chat-history-list>
    </div>
    <div panelFooter class="panel-footer-input">
        <div class="chat-input-container">
            <div class="input-area">
                <div class="ask-eva-container">
                    <div class="input-box" (click)="editMessageId = null">
                        <textarea id="ask-label" class="input-text" [ngClass]="{'error': noInput}" rows="1"
                            [placeholder]="currentPlaceholder" [(ngModel)]="currentMessage"
                            (keydown)="onKeyPress($event)" (input)="onTextareaInput($event)">
                    </textarea>

                        <!-- Buttons positioned inside textarea -->
                        <div class="input-buttons">
                            <button *ngIf="voiceSupported" type="button" class="speech-btn"
                                [ngClass]="{'active-recording': isRecording}" (click)="toggleRecording()"
                                [title]="isRecording ? 'Click to stop recording' : 'Click to start recording'">
                                <span class="mic-symbol" [class.pulsing]="isRecording">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="20" viewBox="0 0 14 20"
                                        fill="none">
                                        <path
                                            d="M7 12.7891C8.66 12.7891 10 11.4491 10 9.78906V3.78906C10 2.12906 8.66 0.789062 7 0.789062C5.34 0.789062 4 2.12906 4 3.78906V9.78906C4 11.4491 5.34 12.7891 7 12.7891ZM6 3.78906C6 3.23906 6.45 2.78906 7 2.78906C7.55 2.78906 8 3.23906 8 3.78906V9.78906C8 10.3391 7.55 10.7891 7 10.7891C6.45 10.7891 6 10.3391 6 9.78906V3.78906ZM12 9.78906C12 12.5491 9.76 14.7891 7 14.7891C4.24 14.7891 2 12.5491 2 9.78906H0C0 13.3191 2.61 16.2191 6 16.7091V19.7891H8V16.7091C11.39 16.2191 14 13.3191 14 9.78906H12Z"
                                            [attr.fill]="isRecording ? '#006BD3' : '#ADAFAF'"
                                            [attr.fill-opacity]="isRecording ? '1' : '0.65'" />
                                    </svg>
                                </span>
                            </button>

                            <button class="send-btn" (click)="sendMessage()" title="Send query">
                                <svg xmlns="http://www.w3.org/2000/svg" width="19" height="17" viewBox="0 0 19 17"
                                    fill="none">
                                    <path
                                        d="M0 16.29V0.290039L19 8.29004L0 16.29ZM2 13.29L13.85 8.29004L2 3.29004V6.79004L8 8.29004L2 9.79004V13.29Z"
                                        fill="#006BD3" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</app-chat-flyout>